<template>
  <div class="course_introduce">
    <div class="course_introduce_content" ref="content" :class="{ expanded: isExpanded }" v-if="practiceList.length">
      <div class="courseware_title flex FlexBetween">
        <div class="courseware_name">章节</div>
        <div class="courseware_chapter">题目数量</div>
        <div class="courseware_chapter">操作</div>
      </div>
      <div class="practice_one courseware_title flex FlexBetween" v-for="(item, index) in practiceList" :key="index"
        :class="[index % 2 == 1 ? 'active_bg' : '']">
        <div class="courseware_name toverflow">{{ item.chapterName }}</div>
        <div class="courseware_chapter">{{ item.questionCount }}</div>
        <div class="courseware_chapter active_text cursor_pointer" @click="goPractice(item.chapterId)">去练习</div>
      </div>
    </div>
    <div v-else>
      <moe-empty url="moe_empty_bg_img.png" emptyText="当前章节暂无随堂练习"></moe-empty>
    </div>
  </div>
</template>

<script>
export default {
  name: "GjkcH5ClassroomPractice",

  props: {
    courseId: {},
  },
  data() {
    return {
      practiceList: [],
    };
  },
  inject: ['updateShowPractice'],
  mounted() {
    this.getClassroomPractice();
  },

  methods: {
    getClassroomPractice() {
      this.$Api.exam
        .getClassroomPractice(this.courseId)
        .then((res) => {
          this.practiceList = res.data.data.filter((item) => item.questionCount != 0);
        })
        .catch(() => { });
    },
    goPractice(id) {
      this.updateShowPractice(true, id);
    }
  },
};
</script>

<style lang="scss" scoped>
.course_introduce {
  // max-height: 550px;
  // overflow: hidden;
  position: relative;

  .course_introduce_content {
    // max-height: 500px;
    // overflow: hidden;
    // padding: 0 30px;

    .courseware_title {
      width: 100%;
      color: #666666;
      margin-top: 20px;
      // padding: 0 25px;
      box-sizing: border-box;
      padding: 0 30px;

      .courseware_name {
        // width: 58%;
        width: 70%;
      }

      .courseware_chapter {
        width: 14%;
        text-align: center;
      }

      .active_text {
        color: rgba(19, 214, 170, 1);
      }
    }

    .practice_one {
      color: #999999;
      line-height: 45px;
    }

    .active_bg {
      background: #fafcff;
    }
  }
}
</style>
